/** INTRAREA ÎN MACHETA DE SITUAȚIE — partea PURĂ: ce se știe despre
 *  arhitectura de pe plan, ca `Vizualizator` să hotărască dacă arată scheletul
 *  de încărcare sau macheta.
 *
 *  `necautata` — nimeni n-a întrebat încă (hook-ul care caută arhitectura
 *  n-a rulat); `in_curs` — se aduce documentul ei; `gata` — e aici sau nu
 *  există. Cât nu e `gata`, macheta nu se construiește: scena albă s-ar fi
 *  construit doar ca să fie aruncată la sosirea arhitecturii.
 *
 *  CONCLUZIA E LIPICIOASĂ. Arhitectura se aduce din nou de multe ori pe
 *  aceeași soluție — la fiecare scriere a agentului de fațadă, la bătaia de
 *  30 s cât macină —, iar fiecare reluare trece iar prin «se încarcă». Dacă
 *  asta ar întoarce starea la `in_curs`, macheta s-ar DEMONTA pe durata
 *  reluării: camera ei (ținută peste reconstrucții, nu peste montări) s-ar
 *  întoarce la preset, iar scheletul ar apărea peste o machetă care era deja
 *  pe ecran (Cătălin, 26.10.2026: «se dă un reset la cameră și îmi apare
 *  puțin alb ca la încărcare»). O reluare se desenează IN LOC, pe scena de
 *  dinainte, până vine cea nouă. Numai altă soluție pornește de la capăt
 *  (`necautata`). */
export type Cautare = "necautata" | "in_curs" | "gata";

/** Starea după ce hook-ul a spus că (nu) se mai încarcă. */
export function dupaIncarcare(stare: Cautare, seIncarca: boolean): Cautare {
  if (stare === "gata") return "gata";
  return seIncarca ? "in_curs" : "gata";
}

/** Starea după o căutare ANULATĂ pe drum: efectul care o pornise s-a reluat
 *  (registrul re-sondat a arătat alt rând, macheta s-a închis) înainte să
 *  vină răspunsul. Nu s-a aflat nimic, deci nu e `gata` — altfel macheta s-ar
 *  monta pe volumele albe și ar sta așa cât se aduce, de la capăt, documentul
 *  cererii reluate. O concluzie de dinainte rămâne (v. mai sus). */
export function dupaAnulare(stare: Cautare): Cautare {
  return stare === "gata" ? "gata" : "necautata";
}
